import React, { useEffect, useRef, useState } from 'react'
import { ScheduleComponent, Day, Week, WorkWeek, Month, Agenda, Inject, ResourcesDirective, ResourceDirective, ViewsDirective, ViewDirective } from '@syncfusion/ej2-react-schedule';
import EditorTemplate from './EditorTemplate';
import Loader from "../../../component/Loader.jsx"
import { CoachAPI } from '../../../api/CoachAPI.js';
import { useSelector } from 'react-redux';
import { CoachSchedulerAPI } from '../../../api/CoachSchedulerAPI.js';
import { onActionComplete, onEventClick, onPopupOpen, onSingleClick } from './CoachScheduleActions.js';
import { SCHEDULE_TYPES } from './SchedulerConstant.js';
import { SubscriptionAPI } from '../../../api/SubscriptionAPI.js';
import { CalendarAPI } from '../../../api/CalendarAPI.js';
import { getWorkingDays } from './SchedulerConfigFunctions.js';
import { getMaximunmTimeInADay, handleTimeOparetionsPerDay, setInitialStartAndEndHour } from '../../../util/CalendarUtil.js';
import { useDispatch } from 'react-redux';
import { calenderAction } from '../../../redux/reducer/calenderReducer.js';
import { contentTemplate, footerTemplate, headerTemplate } from './QuickInfoTemplate.jsx';
import { template } from 'lodash';
import { Internationalization } from '@syncfusion/ej2-base';
import { EventAPI } from '../../../api/EventAPI.js'
import { useLoadScript } from '@react-google-maps/api';
import { Privileges } from '../../../util/PrivilegeConstants.js';
import { PrivilegeAPI } from '../../../api/PrivilegesAPI.js';
import { isClubOwner, isCoach, isUser } from '../../../util/UserRoles.js';
import { DropDownButtonComponent } from '@syncfusion/ej2-react-splitbuttons';
import { DialogComponent } from '@syncfusion/ej2-react-popups/index.js';
import EditorFooterTemplate from './EditorFooterTemplate.jsx';


const libraries = ['places'];


const CoachScheduler = () => {

    const scheduleRef = useRef(null);
    const userInfo = useSelector((store) => store.user.userInfo);
    const selectedClub = useSelector((store) => store.user.selectedClub);
    const [events, setEvents] = useState([]);
    const [coachOrgs, setCoachOrgs] = useState([]);
    const [scheduleData, setScheduleData] = useState([]);
    const [selectedDate, setSelectedDate] = useState(null);
    const [calenderConfig, setCalenderConfig] = useState(null);
    const [isRefresh, setIsRefresh] = useState(false);
    const [privileges, setPrivileges] = useState({});
    const [isCheckoutEnable, setIsCheckoutEnable] = useState(false);
    const [scheduleConfigData, setScheduleConfigData] = useState({
        isUserInvalidToAccess: false,
        game: {},
        resourceData: [],
        courtData: [],
        players: [],
        workingDays: []
    })
    const [loadingState, setLoadingState] = useState({
        loading1: false,
        loading2: false,
        loading3: false,
        loading4: false,
        loading5: false,
    });
    const [currentSelectedDate, setCurrentSelectedDate] = useState('');
    const {
        currentView, weekDayStartTime, weekDayEndTime, dayStartTime, currentGameId,
        dayEndTime, startHour, endHour
    } = useSelector((store) => store.calendar);
    const dispatch = useDispatch();
    const collectScheduleConfig = (key, data) => {
        setScheduleConfigData((prev) => ({
            ...prev,
            [key]: data
        }))
    };
    const startLoading = (key) => {
        setLoadingState((prev) => ({
            ...prev,
            [key]: true
        }))
    };

    const finishLoading = (key) => {
        setLoadingState((prev) => ({
            ...prev,
            [key]: false
        }))
    };
    const findCalendarConfigCheckout = async () => {
        try {
            const response = await CalendarAPI.getCalendarConfigCheckout(selectedClub.clubId);
            setIsCheckoutEnable(response.Data);
        } catch (error) {
            console.log(error);
        }
    };

    const findAllEvent = async () => {
        try {
            startLoading("loading1")
            const response = await EventAPI.getAllEventForListOptions(selectedClub.clubId, userInfo.userId);
            setEvents(response.Data);

        } catch (error) {
            console.error(error);

        } finally {
            finishLoading("loading1")
        }
    }

    const findAllCoachOrg = async () => {
        try {
            startLoading("loading2")
            const response = await CoachAPI.findAllCoachOrg(userInfo.userId);
            setCoachOrgs(response.Data);

        } catch (error) {
            console.error(error);

        } finally {
            finishLoading("loading2")
        }
    }
    const findAllPrivileges = async () => {
        try {
            startLoading()
            const reqObj = {
                userId: userInfo.userId,
                featureName: Object.keys(Privileges)[6]
            }
            const response = await PrivilegeAPI.getAllPrivilegesByFeature(reqObj);
            setPrivileges(response.Data);

        } catch (error) {
            console.error(error);
        } finally {
            finishLoading();
        }
    };
    const transformScheduleData = (data) => {
        //console.log(data);

        return {
            Id: data.scheduleId,
            Subject: data.subject,
            IsReadonly: data.scheduleType === 'BLACK_OUT_DATE',
            StartTime: data.scheduleStartTime,
            EndTime: data.scheduleEndTime,
            Description: data.scheduleDescription,
            Venue: data.venue,
            EventId: data.eventId,
            AwayOrgId: data.awayOrgId,
            HomeTeamId: data.scheduleType === "EVENT" ? data.homeTeamId : "",
            AwayTeamId: data.scheduleType === "EVENT" ? data.awayTeamId : "",
            ScheduleType: data.scheduleType,
            RecurrenceRule: data.recurrenceRule,
            TeamIds: data.teamIds,
            AwayTeamName: data.awayTeamName,
            AwayOrganizationName: data.awayOrganizationName,
            RecurrenceID: data.recurrenceId,
            CourtNumber: data.resourceId ? data.resourceId : scheduleConfigData.courtData.length != 0 ? scheduleConfigData.courtData[0].id : null,
            hideRecurrenceEditor: false,
            MeetingData: data.meetingData,
            AcceptedUser: data.acceptedUser ?? 0,
            PendingUser: data.pendingUser ?? 0,
            IsRSVP: data.rsvp ?? false,
            MaxSlot: data.maxSlot ?? 0,
            ScheduleCreatedBy: data.scheduleCreatedBy,
            IsPaid: data.isPaid,
            IsAttachAllMember: data.isAttachAllMember,
            Status: data.scheduleStatus,
            IsAttachAllGuest: data.isAttachAllGuest
        }
    };
    const fetchSchedulesForDay = async () => {


        try {
            startLoading("loading3");
            const data = {
                gameId: currentGameId,
                startTime: dayStartTime,
                endTime: dayEndTime,
                clubId: selectedClub?.clubId,
                clientTimeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
                userId: userInfo.userId
            }
            const response = await CoachSchedulerAPI.findAllCoachSchedule(data)
            // console.log(response);

            let respData = response.Data;
            const newData = respData.map((data) => transformScheduleData(data));

            setTimeout(() => {
                setScheduleData(newData);
                finishLoading("loading3")
            }, 500);
        } catch (error) {
            finishLoading("loading3")
        }
    }
    const fetchSchedulesForWeek = async () => {


        try {
            startLoading("loading3");
            const data = {
                gameId: currentGameId,
                startTime: weekDayStartTime,
                endTime: weekDayEndTime,
                clubId: selectedClub.clubId,
                clientTimeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
                userId: userInfo.userId
            }
            const response = await CoachSchedulerAPI.findAllCoachSchedule(data);
            let respData = response.Data;
            const newData = respData.map((data) => transformScheduleData(data));
            setScheduleData(newData);

        } catch (error) {

        } finally {
            setTimeout(() => {
                finishLoading("loading3");
            }, 100);
        }
    }

    useEffect(() => {
        if (calenderConfig) {
            setInitialStartAndEndHour(dispatch, calenderConfig, isUser(userInfo));
            setSelectedDate(new Date(new Date().toLocaleString('en-US', { timeZone: calenderConfig.calenderTimezone })))
        }
    }, [calenderConfig, selectedClub.clubId])

    useEffect(() => {
        if (selectedClub?.clubId) {
            fetchAllAPI();
            fetchIsSubscriptionPurchased();
            findAllPrivileges();
            findCalendarConfigCheckout();
        }
    }, [selectedClub?.clubId]);

    useEffect(() => {
        if (scheduleRef && scheduleRef.current) {
            setCurrentSelectedDate(scheduleRef?.current?.getCurrentViewDates())
        }
    }, [scheduleRef?.current, currentSelectedDate, dayStartTime, selectedDate])

    useEffect(() => {
        findAllEvent();
        findAllCoachOrg();
    }, []);


    useEffect(() => {
        if (currentGameId && currentView) {
            // console.log(currentView);

            if ((currentView === 'Day' || currentView === 'TimelineDay')) {
                if (new Date(currentSelectedDate && currentSelectedDate[0]).getDate() == new Date(dayStartTime).getDate()) {
                    fetchSchedulesForDay();
                }
                if (calenderConfig) {
                    handleTimeOparetionsPerDay(scheduleRef, dispatch, calenderConfig);
                }
            } else if (currentView === 'Week' || currentView === 'TimelineWeek' || currentView === 'Month' || currentView === 'Agenda') {
                //console.log("called this ");

                fetchSchedulesForWeek();
                if (calenderConfig) {
                    getMaximunmTimeInADay(dispatch, calenderConfig);
                }
            }
        }
        isRefresh && setIsRefresh(false);
    }, [currentGameId, selectedClub.clubId, currentSelectedDate, dayStartTime, currentView, weekDayStartTime, isRefresh]);


    const fetchIsSubscriptionPurchased = async () => {
        try {
            startLoading("loading4");
            const res = await SubscriptionAPI.isSubscriptionPurchased(userInfo?.userId, selectedClub?.clubId);
            collectScheduleConfig("isUserInvalidToAccess", !res.Data);
        } catch (error) {
        } finally {
            finishLoading("loading4")
        }
    }
    const fetchAllAPI = async () => {
        try {
            startLoading("loading5")
            const apiCalls = [
                CalendarAPI.getCalendarConfig(selectedClub?.clubId),
                CalendarAPI.getAllResourceAndGame({ clubId: selectedClub?.clubId }),
                CoachSchedulerAPI.findPlayerTeamDetails(selectedClub?.clubId, userInfo.userId),
            ];


            const [
                calendarConfig,
                allGames,
                allUsersForAClub
            ] = await Promise.allSettled(apiCalls);


            // Extract responses based on the presence of getAdvanceBooking
            if (calendarConfig.status === "fulfilled") {
                setCalenderConfig(calendarConfig.value.Data)
                collectScheduleConfig("workingDays", getWorkingDays(calendarConfig.value.Data));
            }
            if (allGames.status === "fulfilled") {
                dispatch(calenderAction.setCurrentGameId(allGames.value.Data.games[0]?.gameId))
                collectScheduleConfig("game", allGames.value.Data.games);
                let data = allGames.value.Data.resources;
                const result = data?.map((item) => ({
                    Name: item?.courtNumber,
                    Id: item?.id,
                    Color: item?.color,
                }));
                collectScheduleConfig("resourceData", result);
                collectScheduleConfig("courtData", data);
            }
            if (allUsersForAClub.status === "fulfilled") {
                collectScheduleConfig("players", allUsersForAClub.value.Data);
            }
        } catch (error) {
            console.log(error);

        } finally {
            finishLoading("loading5")
        }

    }



    const instance = new Internationalization();
    const getTimeString = (value) => {
        return instance.formatDate(value, { skeleton: 'hm' });
    }
    const eventTemplate = (props) => {
        const secondaryColor = { background: props.SecondaryColor, padding: currentView === 'Month' ? '0px 5px' : '8px 5px' };
        const primaryColor_1 = { background: props.PrimaryColor, fontWeight: 600, marginBottom: 3 };
        const primaryColor_2 = { background: props.PrimaryColor };
        return (
            <div className="template-wrap" style={secondaryColor}>
                <div className='custom_event_part_1'>
                    <div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px', justifyContent: 'center' }}>
                            <div className="subject" style={primaryColor_1}>{props.Subject}</div>
                            <p className={'custom_event_rsvp'}>{props.Status}</p>
                        </div>
                        <div className="time" style={primaryColor_2}>
                            {getTimeString(props.StartTime)} - {getTimeString(props.EndTime)}
                        </div>
                    </div>
                    {(props?.IsRSVP && props?.IsRSVP) && <p className={'custom_event_rsvp'}>RSVP</p>}
                </div>
                {(props?.IsRSVP && props?.IsRSVP) &&
                    <div className={'custom_event_rsvp_status'}>
                        <p>Joined: {props?.AcceptedUser}</p>
                        <p>Pending: {props?.PendingUser}</p>
                        <p>Available: {props?.MaxSlot}</p>
                    </div>}
            </div>
        );
    }

    const eventSettings = {
        dataSource: scheduleData, ignoreWhitespace: true, template: eventTemplate
    }

    if (loadingState.loading1 || loadingState.loading4 || loadingState.loading5) {
        return <Loader />
    }

    const groupData = {
        resources: ['Resources']
    }

    return (
        <>
            {(loadingState.loading3 || loadingState.loading2) && <Loader />}
            {(selectedClub?.clubId && calenderConfig && selectedDate) &&
                <div className='sm_coach_scheduler_container'>
                    {(scheduleConfigData.isUserInvalidToAccess && 
                    (isClubOwner(userInfo) || 
                    (isCoach(userInfo) && isCheckoutEnable) ||
                     (isUser(userInfo) && privileges?.RESERVATION?.includes(Privileges.CREATE)))) &&
                        <div className='security-mask-on-schedule'>
                            <p>To access the calendar, please purchase a subscription.</p>
                        </div>}
                    <ScheduleComponent height='80dvh'
                        ref={scheduleRef}
                        delayUpdate={true}
                        selectedDate={selectedDate}
                        showTimeIndicator={false}
                        eventSettings={eventSettings}
                        timeScale={{ interval: Number(calenderConfig?.interval) ? Number(calenderConfig.interval) : 30, slotCount: 1 }}
                        cellDoubleClick={(args) => { args.cancel = true }}
                        eventDoubleClick={(args) => { args.cancel = true }}
                        cellClick={(args) => onSingleClick(args, scheduleRef, privileges)}
                        eventClick={(args) => onEventClick(args, scheduleRef, userInfo, calenderConfig,privileges)}
                        popupOpen={(args) => onPopupOpen(args, scheduleRef, userInfo, selectedClub, setIsRefresh, dispatch, calenderConfig,privileges)}
                        actionComplete={(args) => onActionComplete(args, scheduleRef, dispatch)}
                        editorFooterTemplate={(args) => <EditorFooterTemplate
                            args={args}
                            privileges={privileges}
                            selectedClub={selectedClub}
                            scheduleRef={scheduleRef}
                            setIsRefresh={setIsRefresh}
                        />}
                        startHour={startHour}
                        endHour={endHour}
                        workDays={scheduleConfigData.workingDays}
                        showWeekend={false}
                        currentView={'Agenda'}
                        timezone='UTC'
                        quickInfoTemplates={{
                            header: (props) => headerTemplate(props, scheduleConfigData.resourceData, scheduleRef),
                            content: contentTemplate,
                            footer: footerTemplate
                        }}

                        editorTemplate={(args) => <EditorTemplate
                            args={args}
                            userInfo={userInfo}
                            clubId={selectedClub?.clubId}
                            events={events}
                            coachOrgs={coachOrgs}
                            courtData={scheduleConfigData.courtData}
                            calenderConfig={calenderConfig}
                            players={scheduleConfigData.players}
                        />}
                        group={scheduleConfigData?.resourceData?.length == 0 ? null : groupData}
                    >
                        <ViewsDirective>
                            <ViewDirective option="Day" />
                            <ViewDirective option="Week" />
                            <ViewDirective option="Month" />
                            <ViewDirective option="Agenda" />
                        </ViewsDirective>
                        <ResourcesDirective>
                            <ResourceDirective field='CourtNumber' title='Court Number' name='Resources' textField='Name' idField='Id' colorField='Color' dataSource={scheduleConfigData.resourceData} />
                        </ResourcesDirective>
                        <Inject services={[Day, Week, Month, Agenda]} />
                    </ScheduleComponent>
                </div>
            }
        </>

    );
}

export default CoachScheduler